import { render, staticRenderFns } from "./DbSource.vue?vue&type=template&id=2cd63e1a&scoped=true"
import script from "./DbSource.vue?vue&type=script&lang=js"
export * from "./DbSource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd63e1a",
  null
  
)

export default component.exports